module.exports = __webpack_public_path__ + "img/ck-four.eef59526.png";